import {
  App,
  Modal as StaticModal,
  message as staticMessage,
  notification as staticNotification,
} from 'antd';

/** antd <App> 提供的实例类型，跟随 antd 版本自动对齐 */
type FeedbackInstance = ReturnType<typeof App.useApp>;

let instance: FeedbackInstance | null = null;

/** 由 AppProvider 内的 FeedbackBridge 注入 antd App 实例 */
export const bindFeedback = (next: FeedbackInstance) => {
  instance = next;
};

/**
 * 全局反馈（对应 vue-naive-admin 里的 $message / $dialog）
 *
 * 优先使用 antd <App> 提供的实例，这样弹层能拿到 ConfigProvider 的主题与语言；
 * 在 React 之外（如请求拦截器）调用时回退到 antd 静态方法。
 */
export const feedback = {
  get message() {
    return instance?.message ?? staticMessage;
  },
  get notification() {
    return instance?.notification ?? staticNotification;
  },
  get modal() {
    return instance?.modal ?? StaticModal;
  },
};
